import React from 'react';

import { createChipWihFadingBackgroundVariations } from '~/src/dash/components/model-chip';
import { publicaColors } from '~/src/dash/utils/colors';

export const ChipTranscodeStatus = (textColor: string, baseColor: string, label: string) => {
  const BaseChipTranscodeStatus = createChipWihFadingBackgroundVariations(
    textColor,
    baseColor,
    baseColor,
    baseColor,
    true,
    true,
  );
  return <BaseChipTranscodeStatus clickable={false} label={label} style={{ width: '128px' }} />;
};

export const ChipTranscodeStatusProcessing = createChipWihFadingBackgroundVariations(
  publicaColors.yellow,
  publicaColors.veryLightYellow,
  publicaColors.veryLightYellow,
  publicaColors.veryLightYellow,
  true,
  true,
);

export const ChipTranscodeStatusComplete = createChipWihFadingBackgroundVariations(
  publicaColors.jungleGreen,
  publicaColors.mint,
  publicaColors.mint,
  publicaColors.mint,
  true,
  true,
);

export const ChipTranscodeStatusPending = createChipWihFadingBackgroundVariations(
  publicaColors.black,
  publicaColors.veryLightGray,
  publicaColors.veryLightGray,
  publicaColors.veryLightGray,
  true,
  true,
);
